import classnames from 'classnames';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Preloader from '../../../components/common/Preloader';
import { getEventCardsAbbr, getEventGoalsAbbr } from '../../../modules/events/selectors';

const renderKeyEventItem = (item, itemClassName, iconClassName) => (
  <div className={itemClassName} key={`${item.time}${item.playerNumber}`}>
    <i className={iconClassName} />
    <span className="key-events__event-time">{item.time}</span>
    <span className="key-events__event-player">{item.playerName}</span>
  </div>
);

const cardIcon = card => classnames('key-events__card', {
  'key-events__card--yellow': card.type === 'YELLOW',
  'key-events__card--red': card.type === 'RED'
});

export const KeyEvents = ({ goals, cards }) => {
  if (!goals || !cards) {
    return (
      <div className="key-events">
        <div className="key-events__box">
          <Preloader>Waiting for stats...</Preloader>
        </div>
      </div>
    );
  }

  const homeClassName = 'key-events__event key-events__event--right';
  const awayClassName = 'key-events__event';
  const footballIcon = 'icon icon--football key-events__goal';

  return (
    <div className="key-events">
      <div className="key-events__box">
        {(goals.home.size || goals.away.size) ? (
          <div className="key-events__teams">
            <div className="key-events__team">
              <div className="key-events__group key-events__group--right">
                {goals.home.map(g => renderKeyEventItem(g, homeClassName, footballIcon))}
              </div>
            </div>
            <div className="key-events__team">
              <div className="key-events__group">
                {goals.away.map(g => renderKeyEventItem(g, awayClassName, footballIcon))}
              </div>
            </div>
          </div>
        ) : 'No goals.'}
      </div>
      <div className="key-events__box">
        {(cards.home.size || cards.away.size) ? (
          <div className="key-events__teams">
            <div className="key-events__team">
              <div className="key-events__group key-events__group--right">
                {cards.home.map(c => renderKeyEventItem(c, homeClassName, cardIcon(c)))}
              </div>
            </div>
            <div className="key-events__team">
              <div className="key-events__group">
                {cards.away.map(c => renderKeyEventItem(c, awayClassName, cardIcon(c)))}
              </div>
            </div>
          </div>
        ) : 'No cards.'}
      </div>
    </div>
  );
};

KeyEvents.propTypes = {
  goals: PropTypes.shape({
    home: PropTypes.instanceOf(List),
    away: PropTypes.instanceOf(List)
  }),
  cards: PropTypes.shape({
    home: PropTypes.instanceOf(List),
    away: PropTypes.instanceOf(List)
  })
};

const mapStateToProps = (state, props) => ({
  goals: getEventGoalsAbbr(state, props),
  cards: getEventCardsAbbr(state, props)
});

export default connect(mapStateToProps)(KeyEvents);
